/**
 * Why a photo request could not be created. Creation is guarded rather than
 * queued-then-rejected, so each reason says what to do next.
 */
export const ITEM_PHOTO_REQUEST_BLOCKED = "ITEM_PHOTO_REQUEST_BLOCKED";

export const ItemPhotoRequestBlockedReason = {
  /** The item has no product, so there is nothing to photograph. */
  noProduct: "no_product",
  alreadyOpen: "already_open",
  /** The named directions were deleted, or belong to someone else. */
  requirementsNotFound: "requirements_not_found",
  itemNotFound: "item_not_found",
} as const;
export type ItemPhotoRequestBlockedReason =
  (typeof ItemPhotoRequestBlockedReason)[keyof typeof ItemPhotoRequestBlockedReason];

export const itemPhotoRequestBlockedMessage: Record<
  ItemPhotoRequestBlockedReason,
  string
> = {
  [ItemPhotoRequestBlockedReason.noProduct]:
    "This inventory item is not linked to a product, so there is nothing to photograph.",
  [ItemPhotoRequestBlockedReason.alreadyOpen]:
    "There is already an open photo request for this item.",
  [ItemPhotoRequestBlockedReason.requirementsNotFound]:
    "Those photo requirements no longer exist. Pick another set, or create one.",
  [ItemPhotoRequestBlockedReason.itemNotFound]: "Inventory item not found.",
};
